(() => {
  const theme = window.Theme;
  const config = theme?.wholesaleSearch;

  if (!config?.enabled || !config.exclusion) return;

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const exclusionPattern = new RegExp(`\\s*${escapeRegExp(config.exclusion)}\\b`, 'gi');
  const notTagPattern = config.productTag
    ? new RegExp(`\\s*(?:AND\\s+)?NOT\\s+tag:${escapeRegExp(config.productTag)}\\b`, 'gi')
    : null;

  const stripExclusion = (query) => {
    let displayQuery = String(query || '').replace(exclusionPattern, '');

    if (notTagPattern) {
      displayQuery = displayQuery.replace(notTagPattern, '');
    }

    return displayQuery.replace(/\s+/g, ' ').trim();
  };

  const hasExclusion = (query) => {
    const normalizedQuery = String(query || '').toLowerCase();
    const normalizedExclusion = String(config.exclusion).toLowerCase();
    const normalizedTag = String(config.productTag || '').toLowerCase();

    return (
      normalizedQuery.includes(normalizedExclusion) ||
      (normalizedTag.length > 0 && normalizedQuery.includes(`tag:${normalizedTag}`) && normalizedQuery.includes('not'))
    );
  };

  const withExclusion = (query) => {
    const cleanQuery = stripExclusion(query);

    if (!cleanQuery || hasExclusion(query)) {
      return query;
    }

    return `${cleanQuery} ${config.exclusion}`;
  };

  const syncSearchInputs = (root = document) => {
    for (const input of root.querySelectorAll('form input[name="q"]')) {
      const displayValue = stripExclusion(input.value);

      if (displayValue !== input.value) {
        input.value = displayValue;
      }
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action) return;

      const action = new URL(form.action, window.location.origin);

      if (action.pathname !== theme.routes.search_url) return;

      const input = form.querySelector('input[name="q"]');

      if (!(input instanceof HTMLInputElement)) return;

      input.value = withExclusion(input.value);
    },
    true
  );

  syncSearchInputs();

  document.addEventListener('DOMContentLoaded', () => syncSearchInputs());
})();
